import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import SearchBar from '../Components/SearchBar'
import env from '../ENV';
import authInstance from '../Classes/AuthHandler';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux'
import FormatDate from '../Classes/FormatDate';
import POCommentPopUp from '../Components/POCommentPopUp';
import { getallAcceptedDeliveryScheduleDetailforSupplier } from '../store/actions/expediting.Actions';
import numberWithCommas from '../Classes/NumberwithComma'
import dateFormater from '../Classes/FormatDate'
const FILESERVER_ROOT_URL = env.FILE_SERVER_URL;

function formatDate(date) {
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();
  if (month.length < 2)
    month = '0' + month;
  if (day.length < 2)
    day = '0' + day;
  return [day, month, year].join('-');
}

class ExpeditingApprovedExpediting extends React.Component {

  constructor(props) {
    super(props);
    this.state = {

      allChecked: false,
      supplierName: "ABC Tech Inc.",
      select: true,
      checkbox: false,
      open: false,
      checked: [],
      opacity: "",
      comments: '',
      searchTerm: null,
      formattedData: [],
      selectAll: false,
      modal: false,
      lorryreceiptmodal: false,
      multiCollapseIndex: "",
      POCommentPopUpModal: false,
      POId: "",
      PoLineItemId: ""
    }

    this.comments = this.comments.bind(this);
    this.togglebutton = this.togglebutton.bind(this);
    this.POCommentPopUpModal = this.POCommentPopUpModal.bind(this);
    // this.handleChange = this.handleChange.bind(this);
    // this.handleSingleCheckboxChange = this.handleSingleCheckboxChange.bind(this);


  }
  // action1() {
  //   this.setState({ action1: false });
  // }

  togglebutton = (Index) => {

    var multiCollapseIndex = this.state.multiCollapseIndex

    if (multiCollapseIndex != Index || multiCollapseIndex == '') {
      this.setState({ multiCollapseIndex: Index })
    }
  }

  // handleChange = () => {
  //   var selectAll = !this.state.selectAll;
  //   this.setState({ selectAll: selectAll });
  //   var checkedCopy = [];
  //   this.state.array2.map(function (e, index) {
  //     checkedCopy.push(selectAll);
  //   });
  //   this.setState({
  //     checked: checkedCopy
  //   });
  // };

  // handleSingleCheckboxChange = index => {
  //   console.log(index);
  //   var checkedCopy = this.state.checked;
  //   checkedCopy[index] = !this.state.checked[index];
  //   if (checkedCopy[index] === false) {
  //     this.setState({ selectAll: false });
  //   }
  //   this.setState({
  //     checked: checkedCopy
  //   });
  // };


  // toggleSuccessModal(e) {
  //   this.setState({ modal: !this.state.modal });
  //   if (this.state.modal == true) {
  //     this.setState(
  //       { opacity: "" }
  //     )
  //   }
  //   else {
  //     this.setState(
  //       { opacity: "0.2" }
  //     )
  //   }
  // }

  comments(event) {
    this.setState({ comments: event.target.value })
    // console.log(this.state.comments,"comments") ;
  }


  // handleClick = () => {
  //   var datePattern = document.getElementById('myDate').value;
  //   document.getElementById("demo").innerHTML = datePattern;
  // }
  onclickDownload = async (documentID) => {
    var url = FILESERVER_ROOT_URL + "files/Documents/" + documentID + "/download"
    window.location.href = url
  }

  handleISearch = (e) => {
    let searchTerm = e.target.value
    this.setState({ searchTerm })
  }

  handleSearching = async () => {

    var roles = Object.keys(authInstance.getRoles())[0]
    var user = authInstance.getUserID()
    if (roles == 5)
      this.props.getallAcceptedDeliveryScheduleDetailforSupplier(user, this.state.searchTerm)
    if (roles == 7)
      this.props.getallAcceptedDeliveryScheduleDetailforSupplier(0, this.state.searchTerm)

  }
  
  handlerefresh(){
    window.location.reload()
  }

  componentDidMount() {
    console.log(authInstance.getUserPayLoad())
    var roles = Object.keys(authInstance.getRoles())[0]
    console.log(roles,"&&&&&&&&&&&&&&&&&&&&&&&&")
    var user = authInstance.getUserID()

    if (roles == 5)
      this.props.getallAcceptedDeliveryScheduleDetailforSupplier(user, this.state.searchTerm)
    // if (roles == 7 || roles== 12 || roles == 17 || roles== 18 || roles== 6)
    else
      this.props.getallAcceptedDeliveryScheduleDetailforSupplier(0, this.state.searchTerm)

  }

  POCommentPopUpModal() {
    this.setState({ POCommentPopUpModal: !this.state.POCommentPopUpModal });
    this.setState({ RetentionDocumentsModal: false });
    if (this.state.POCommentPopUpModal == true) {
      this.setState(
        { opacity: "" }
      )
    }
    else {
      this.setState(
        { opacity: "0.2" }
      )
    }
  }

  togglePOCommentPopUpModal(e) {
    this.setState({ POCommentPopUpModal: !this.state.POCommentPopUpModal });
    if (this.state.POCommentPopUpModal == true) {
      this.setState(
        { opacity: "" }
      )
    }
    else {
      this.setState(
        { opacity: "0.2" }
      )
    }
  }
  rowClick (index) {
    let poId = this.props.dsdetails.accepteddeliveryScheduledetails.recordset[index].PurchaseOrderId
    let poLineId = this.props.dsdetails.accepteddeliveryScheduledetails.recordset[index].PurchaseOrderId
    // console.log(this.props.dsdetails.accepteddeliveryScheduledetails.recordset[index].PurchaseOrderId, "idddd")
    // console.log(this.props.dsdetails.accepteddeliveryScheduledetails.recordset[index].PurchaseOrderLineId, "idddd")
    this.setState({ POId : poId, PoLineItemId : poLineId })
    console.log(this.state.PurchaseOrderLineId,this.state.PurchaseOrderId,"WWWW")
    this.POCommentPopUpModal()
  }

  render() {
    var roles = authInstance.getRoles()
    var groups = authInstance.getGroups()
    let Id1 = this.state.POId
    let Id2 = this.state.PoLineItemId

    // console.log(this.props.dsdetails.accepteddeliveryScheduledetails.recordset)
    return (

      <div className="Container-fluid pageheight"  >
        {/*----------Document comment-------------- */}
        {
          Id1 && Id2 ? (<POCommentPopUp action={this.state.POCommentPopUpModal} togglePOCommentPopUpModal={(e) => this.togglePOCommentPopUpModal(e)} POId = {Id1} PoLineItemId = {Id2} path='/ExpeditingApprovedPOAcceptance' />) : null
        }
        {/*----------Document Comment end  */}
        <div className="Container-fluid p-4" >

          <div className="row pr-4" >
            <div className="col-md-7 "> </div>
            <div className="col-md-1 mt-3">
              <FontAwesomeIcon icon={"sync-alt"} color="black" title="Refresh" size="lg" onClick={this.handlerefresh} />  
            </div>
            <div className="col pt-2  xs={last}">
              <SearchBar placeholder="Search" value={this.state.searchTerm} searchInputHandler={(e) => { this.handleISearch(e) }} searchClick={this.handleSearching} label="Search" btnName="" />
            </div>
          </div>

          <div className="row-md-8 pr-4">
            <div className="col ">

              <div className="row  headerbar ">
                <div className="col-md-2 pt-2 pb-2 borderheaderbar">PO Number</div>
                <div className="col-md-2 pt-2 pb-2 borderheaderbar ">PO Item</div>
                <div className="col-md-2 pt-2 pb-2 borderheaderbar d-none d-sm-block">PO Amount</div>
                <div className="col-md-3 pt-2 pb-2 borderheaderbar">Status </div>
                <div className="col-md-3 pt-2 pb-2 borderheaderbar">Action </div>
              </div>

              {this.props.dsdetails.accepteddeliveryScheduledetails && this.props.dsdetails.accepteddeliveryScheduledetails.recordset && this.props.dsdetails.accepteddeliveryScheduledetails.recordset.length > 0 && this.props.dsdetails.accepteddeliveryScheduledetails.recordset.map((element, Index) =>

                <div className={Index % 2 == 0 ? 'row border ' : 'row  background '} onClick={() => this.togglebutton(Index)} data-toggle="collapse" data-target={`.multi-collapse${Index}`}>
                  <div className="col-md-2 pt-2 pb-2 borderheaderbar headeralign">{element.POSAPId}</div>
                  <div className="col-md-2 pt-2 pb-2 borderheaderbar headeralign ">{element.POLineItemSAPCode}</div>
                  <div className="col-md-2 pt-2 pb-2 borderheaderbar amount-text headeralign ">{numberWithCommas(element.POLineItemAmount)}</div>
                  <div className="col-md-3 pt-2 pb-2 borderheaderbar headeralign ">{element.ExpeditingStatusName}</div>
                  <div className="col-md-3 pt-2 pb-2 borderheaderbar headeralign ">
                    <FontAwesomeIcon icon={"sms"} style={{ marginRight: "15px", cursor: "pointer" }} color={"block"} title="Comments" size="lg" onClick={() => this.rowClick(Index)} />
                    <Link to={{ pathname: '/ExpeditingPOAcceptanceTrail', state: { poId: element.PurchaseOrderId, lineItemID: element.PurchaseOrderLineId } }}>
                      <FontAwesomeIcon icon={"eye"} color="black" title="View" size="lg" />
                    </Link>
                  </div>

                  <div style={{maxWidth:"1400px"}} className={Index == this.state.multiCollapseIndex ? ` pt-2 mb-2 detailpanebackground container collapse multi-collapse${Index}` : `container collapse`}>
                    <form>
                      <div></div>
                      <div className="row">
                        <div className="col-md-3">
                          <b>WBS No: </b>
                        </div>
                        <div className="col">
                          {element.WBSCode}
                        </div>

                        <div className="col-md-4">
                          <b>Location: </b>
                        </div>
                        <div className="col">
                          {element.Location}
                        </div>
                      </div>

                      {!roles[5]== true ?
                        <>
                        <div className="row mt-2">
                          <div className="col-md-3">
                          <b>Expected Delivery Date: </b>
                        </div>
                        <div className="col">
                          {dateFormater(element.ExpectedDeliveryDate)}
                        </div>
                        <div className="col-md-4">
                          <b>Document Submission Due Date: </b>
                        </div>
                        <div className="col">
                          {dateFormater(element.DocumentSubmissionDueDate)}
                        </div>
                      </div>
                        </>
                      :<>
                        <div className="row mt-2">
                          <div className="col-md-3">
                          <b>PO Delivery Date: </b>
                        </div>
                        <div className="col">
                          {dateFormater(element.PODeliveryDate)}
                        </div>
                        <div className="col-md-4">
                          <b>Document Submission Due Date: </b>
                        </div>
                        <div className="col">
                          {dateFormater(element.DocumentSubmissionDueDate)}
                        </div>
                      </div>
                      </>
                        }
                      

                      <div className="row mt-2">
                        <div className="col-md-3">
                          <b>PO Created On </b>
                        </div>
                        <div className="col">
                          {dateFormater(element.POCreationDate)}
                        </div>

                        <div className="col-md-4">
                          <b>PO Document: </b>
                        </div>
                        <div className="col">
                          <FontAwesomeIcon icon={"file-download"} color={"black"} title="Upload" size="2x" onClick={() => this.onclickDownload(element.DocumentId)} />
                        </div>
                      </div>

                      <div className="row mt-2">
                        <div className="col-md-3">
                          <b>PO Acceptance Document: </b>
                        </div>
                        <div className="col">
                          <FontAwesomeIcon icon={"file-download"} color={"black"} title="Upload" size="2x" onClick={() => this.onclickDownload(element.DocumentId)} />
                        </div>

                        <div className="col-md-4">
                          <b>Delivery Schedule: </b>
                        </div>
                        <div className="col">
                          <FontAwesomeIcon icon={"file-download"} color={"black"} title="Upload" size="2x" onClick={() => this.onclickDownload(element.DocumentId)} />
                        </div>
                      </div>

                      <br />
                    </form>
                  </div>
                </div>
              )}
              <br />
              <br />

            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({ dsdetails: state.expediting })
export default connect(mapStateToProps, { getallAcceptedDeliveryScheduleDetailforSupplier })(ExpeditingApprovedExpediting);